import gate from '@/api/axios';

/**
 * Загружает вложения на сервер
 * @async
 * @function uploadAttachment
 * @param {FormData} payload
 * @returns {Promise}
 */
export const uploadAttachment = async (payload) => gate.post('/attach', payload);

export default {
  uploadAttachment,
};
